import { ArgumentError } from '../utils/errors';

import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class UserRoleOrganizationModel extends BaseAPIModel {
    fields() {
        // objects does not have PK but pk in fields is required in delete method for "this.pk" ...
        return {
            fake: { primaryKey: true, readOnly: true }
        };
    }

    delete(...args) {
        return this.destroy(...args);
    }

    static listUrl({ role, organizationId }) {
        if (!role) {
            throw new ArgumentError(`[Model][UserRoleOrganizationModel][getAll] role is mandatory`);
        }
        if (!organizationId) {
            throw new ArgumentError(`[Model][UserRoleOrganizationModel][getAll] organizationId is mandatory`);
        }

        return `/ticket/organizations/${organizationId}/roles/${role}/users/`;
    }
}
